// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/fonts/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/cross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Plus Jakarta Sans";
  src: local("Plus Jakarta Sans"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
:root {
  --primary-color: #4403bf;
  --secondary-color: #fff;
  --darker-color: #290273;
  --lighter-color: #9275ed;
  --subtle-color: #d3c8ff;
  --success-color: #06c270;
  --info-color: #0063f7;
  --warning-color: #ffcc00;
  --error-color: #ff3b3b;
  --dark-1: #3a3a3c;
  --dark-2: #6b7588;
  --dark-3: #8f90a6;
  --dark-4: #c7c9d9;
  --light-1: #dde5e9;
  --light-2: #ebebf0;
  --light-3: #f2f2f5;
  --light-4: #fafafc;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 !important;
}

body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
  padding: 0% !important;
}

/* Button Styles */
.btn {
  color: var(--secondary-color);
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.top-screen-navbar {
  background-color: white !important;
}

.sticky-sidebar-styles {
  position: fixed;
  top: 0;
  left: 0;
  width: 16.6666667%;
  overflow-y: auto;
  z-index: 100;
  align-items: flex-start;
  height: 100%;
  background-color: var(--dark-1);
}

.navlink-styles {
  padding-left: 18px !important;
}

.selected-sidebar-link {
  background-color: #4403bf !important;
}

.offcanvas {
  width: 70% !important;
  background-color: var(--dark-1) !important;
  color: white !important;
  z-index: 2;
  padding-left: 0px;
}

.discussion-color {
  color: white !important;
}

.sel-discussion-color {
  color: #4403bf !important;
}

.sel-discussion-color:hover {
  color: #4403bf !important;
}

.offcanvas-body {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

/* Define the scrollbar style */
.sticky-sidebar-styles::-webkit-scrollbar {
  display: none;
}

/* Header Styles */
.navbar {
  background-color: var(--dark-1);
  color: var(--secondary-color);
}

.custom-margin-right {
  margin-right: 10px;
  /* Adjust the value as needed */
}

/* Card Styles */
.card {
  background-color: var(--secondary-color);
  color: var(--primary-color);
}

/* Sidebar Styles */
.sidebar {
  color: var(--secondary-color);
  background-color: var(--dark-1);
  height: auto;
}

/* Add these styles in your CSS or use a separate stylesheet */
.sidebar-container {
  background-color: #343a40;
  /* Dark background color */
  height: 100vh;
  overflow-x: hidden;
  width: 250px;
  /* Adjust the width as needed */
  position: fixed;
  transition: width 0.3s;
  /* Add transition for smoother animation */
}

.sidebar-container .navbar {
  width: 100%;
}

.sidebar-container .navbar-toggler {
  border: none;
  padding: 0;
}

.sidebar-container .navbar-toggler-icon {
  background-color: #fff;
  /* Color of the hamburger icon */
}

.sidebar-container .navbar-collapse {
  padding: 20px;
}

.sidebar-container .navbar-nav {
  width: 100%;
}

.sidebar-container .nav-link {
  color: #fff;
  /* Text color */
}

.nav-link:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div div:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div div svg:hover {
  color: #fff !important;
  /* Hover text color */
}

.sidebar-container .navbar-nav .active > .nav-link,
.sidebar-container .navbar-nav .nav-link.active,
.sidebar-container .navbar-nav .nav-link.show,
.sidebar-container .navbar-nav .show > .nav-link {
  background-color: #495057;
  /* Background color for active/hovered link */
}

.navbar .nav-link.heading::before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  /* Adjust the height of the line as needed */
  background-color: #6e6e6f;
  /* Use the appropriate color */
  opacity: 10;
  position: absolute;
  top: 0;
  left: 0;
}

.sidebar-item {
  transition: color 0.3s;
  /* Add a smooth transition effect */
  cursor: pointer;
  /* Change cursor to a hand */
}

.sidebar-item:hover {
  /* Bright white color on hover */
  color: #fff;
  /* Change text color on hover if needed */
  opacity: 1;
}

/* Add these styles in your styles/theme.scss or a separate CSS file */
.mobile-view {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--light-4);
  /* Adjust this color as needed */
  padding: 10px;
  /* Adjust this padding as needed */
}

.mobile-view .nav-link {
  flex-grow: 1;
}

/* Add these styles in your CSS or use a separate stylesheet */
.sidebar-item .dropdown-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: #fff transparent transparent transparent;
  transition: transform 0.3s;
  /* Add transition for smoother animation */
}

.logout-dropdown .dropdown-menu.show {
  position: absolute !important;
  left: -147px;
}

.questionBank .dropdown-menu {
  position: relative !important;
  transform: none !important;
  border: none;
}

.sidebar-item .dropdown-menu {
  position: absolute;
  top: 100%;
  /* Adjust positioning to prevent overlap */
  left: 0;
  width: 100%;
  padding: 10px;
  background-color: #343a40;
  /* Dark background color */
  transition: max-height 0.3s ease-in-out;
  /* Add transition for smoother animation */
  max-height: 0;
  overflow: hidden;
  z-index: 1;
  /* Ensure the dropdown is above other elements */
}

.dropdown-toggle::after {
  display: none !important;
  /* Hide default arrow */
}

.sidebar-item:hover .custom-arrow {
  transform: rotate(180deg);
}

.coursework-sidebar {
  width: 100%;
  background-color: white;
  height: 100%;
  color: black;
  border: 1px solid lightgrey;
}

.coursework-content {
  padding: 10px 0px 0px 20px;
}

.coursework-heading {
  padding: 25px 0px 0px 20px;
}

.coursework-sidebar ul {
  padding: 0;
  list-style: none;
}

.coursework-sidebar li {
  padding: 2px;
  margin-bottom: 10px;
}

.coursework-sidebar li a {
  text-decoration: none;
  color: black;
}

.profile_main_div {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.react-tel-input .form-control {
  width: 100% !important;
  height: 42px !important;
  font-size: 16px !important;
}

.right-side .form-control {
  height: 42px !important;
  font-size: 16px !important;
}

.right-side .input-group {
  height: 42px !important;
  border: 1px solid #e9eaf0;
}

.input-style {
  padding: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
  line-height: 1.5 !important;
}

.form-check-input:checked {
  background-color: #0d6efd !important;
}

.input-placeholder {
  color: #c7c9d9;
}

.modal-body .multiValue {
  border-radius: 50px !important;
}

.button-style {
  box-sizing: border-box;
  border-radius: 5px;
  background: #4403bf;
  justify-content: flex-start;
  align-items: center;
  display: center;
  color: white;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04px;
  word-wrap: break-word;
  border: none;
  cursor: pointer;
  text-align: center;
}

/* styles/Login.css */
.login-container {
  display: flex;
  min-height: 100vh;
}

.login-heading {
  margin-bottom: 20px;
  margin-top: 20px;
}

.left-side {
  min-height: 100vh;
  flex: 3 1;
  background: #ffeee8;
  position: sticky;
  top: 0;
}

.mobile-create-btns {
  width: 70%;
}

mobile-create-btns {
  width: 70%;
}

.mobile-forgot {
  display: none;
}

.forgot-icon {
  display: none;
}

.otp-icon-div {
  margin-bottom: 20px;
}

.right-side {
  flex: 3 1;
  padding: 40px 144px 40px 100px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}

label {
  font-size: 13px;
  display: block;
  color: #8f90a6;
}

/* Add your styles for Input, Button, and other elements here */
.forgot-password-link {
  margin-top: 10px;
  text-decoration: none;
  cursor: pointer;
  color: #4403bf;
}

.otp-phone {
  color: #0063f7;
}

.google-button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  justify-content: flex-start;
  align-items: center;
  display: center;
  color: #3a3a3c;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04px;
  word-wrap: break-word;
  border: 1px solid white;
  box-shadow: 2px 2px 4px rgba(94, 92, 92, 0.64);
  cursor: pointer;
  text-align: center;
}

.google-icon {
  margin-right: 10px;
}

.signup-link {
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  color: #4403bf;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  margin-top: 3px;
}

.breadcrumb-item a {
  text-decoration: none !important;
  color: #4403bf;
}

.categoriesAccordion .accordion-item:first-of-type .accordion-button {
  background-color: white;
}

.profile_main_div .dropdown-menu .show {
  left: -146px !important;
  top: 40px;
}

.filter-students .dropdown-menu .show {
  left: 0px !important;
}

.delete-edit-icon {
  height: 40px;
  padding: 9.99px;
  justify-content: flex-start;
  align-items: center;
  gap: 10.99px;
  display: inline-flex;
  background-color: white;
}

.delete-edit-stu-icon {
  height: 40px;
  padding: 9.99px;
  justify-content: flex-start;
  align-items: center;
  gap: 10.99px;
  display: inline-flex;
}

.delete-edit-stu-icon img {
  width: 20px !important;
}

.delete-edit-icon img {
  width: 20px !important;
}

.save-btn {
  width: auto;
}

.deleteBtnModal {
  border-radius: 28px;
  border: 8px solid rgba(217, 247, 42, 0.2);
  background: rgba(217, 247, 42, 0.3);
  color: #290273;
}

.mblCards {
  display: flex;
  justify-content: space-between;
}

.card-header {
  background-color: #ffffff !important;
}

.mblCards-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

table {
  border: 1.391px solid var(--Grey_2, #e4e4e4);
  border-radius: 5px;
}

tr {
  height: 55px !important;
  text-align: start !important;
}

td {
  position: relative;
  height: 55px !important;
  padding: 12px 24px !important;
  text-align: start !important;
  width: inherit !important;
}

td > div:first-child {
  height: 100% !important;
  display: flex;
  align-items: center;
  width: 100% !important;
}

th {
  position: relative;
  padding: 12px 24px !important;
}

.table-checkbox {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

.table-checkbox:checked {
  background-color: #290273 !important;
}

.mbl-card-checkbox {
  width: 18px !important;
  height: 18px !important;
}

.card-heading {
  font-size: 14px;
  color: var(--Grey_4, #1b2128);
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.Accordion-card {
  height: 60px !important;
  border-radius: 6px 6px 0px 0px !important;
}

.Accordion-card .card-header {
  height: 100% !important;
}

.sm-table {
  display: none;
}

.tox-promotion-link {
  display: none !important;
}

.options-addQuestion p {
  margin: 0 !important;
}

.formattedText p {
  margin: 0 !important;
}

.tox-statusbar {
  display: none !important;
}

.equation_image {
  position: relative;
  max-width: 75% !important;
}

.equation_tooltip {
  display: none;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #000;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
}

.equation_image:hover + .equation_tooltip {
  display: block;
}

.mq-math-mode .mq-sqrt-prefix {
  left: 0.3em !important;
  top: 0.2em !important;
}

.mq-math-mode sup.mq-nthroot {
  padding-top: 0.3em !important;
}

.accordion-button {
  height: 100%;
  background-color: transparent !important;
}

.custom-select__multi-value__remove {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  /* Set appropriate width and height for your custom image */
  width: 20px;
  height: 20px;
  /* Ensure the image is displayed properly */
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  border: none !important;
  /* Ensure cursor changes on hover */
}

#custom-switch {
  width: 45px;
  height: 25px;
}

.accordion-button {
  padding: 8px 16px !important;
}

.formattedText {
  gap: 5px;
  line-height: 30px;
}

.formattedText > span:first-child {
  width: -moz-fit-content;
  width: fit-content;
}

.inlineMath {
  display: inline;
}

/* Add media queries for responsiveness */
@media (max-width: 780px) {
  .login-container .left-side {
    display: none;
  }
  .login-container .right-side {
    padding: 0px 20px 0px 20px;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
  }
  .forgot-icon {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
  }
  .mobile-forgot {
    display: block !important;
    text-align: center !important;
    padding-bottom: 30px;
  }
  .otp-main-div {
    width: 100% !important;
  }
  .otp-icon-div {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
    margin-top: 40px;
  }
  .otp-heading {
    font-size: 20px;
  }
  .otp-phone {
    font-size: 20px;
  }
  .mobile-create-btns {
    width: 90% !important;
    position: fixed;
    bottom: 90px;
    z-index: 1000;
  }
  .mobile-create-btns-2nd {
    width: 90% !important;
    position: fixed;
    bottom: 145px;
    z-index: 1000;
  }
  .login-container {
    flex-direction: column;
  }
  .right-side {
    flex: 1 1;
  }
  .delete-edit-icon {
    height: 100%;
    padding: 8.99px;
    border: none !important;
    justify-content: flex-start;
    align-items: center;
    gap: 10.99;
    display: inline-flex;
  }
  .delete-edit-icon img {
    width: 20px !important;
  }
  .save-btn {
    width: 100% !important;
  }
  .fix-width-button {
    width: 100px !important;
  }
  .fix-width-action-button {
    width: 140px !important;
  }
  .content-div {
    height: 55vh;
    overflow-y: auto;
  }
}
@media (max-width: 780px) and (max-width: 768px) {
  .content-div {
    padding: 7px;
  }
}
@media (max-width: 780px) {
  .sidebar {
    background-color: #ffffff;
  }
  .lg-table {
    display: none !important;
  }
  .sm-table {
    display: inline-table;
  }
  td > div:first-child {
    height: 100% !important;
    display: flex;
    align-items: center;
    width: 100% !important;
    justify-content: flex-start !important;
  }
}
@media (max-width: 500px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 270px;
    /* Adjust this value to your liking */
  }
}
@media (max-width: 400px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
    /* Adjust this value to your liking */
  }
}
@media (max-width: 350px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    /* Adjust this value to your liking */
  }
}
.subscription-info {
  display: flex;
  align-items: center;
}

.subscription-box {
  background-color: blue !important; /* Adjust this color to match your design */
  color: white;
  padding: 11px 14px;
  border-radius: 5px;
  margin-right: 15px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}

.logout-dropdown .dropdown-toggle {
  background: none !important;
  border: none !important;
  padding: 0;
}

.ql-editor {
  white-space: normal !important;
}

.distractor-section {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.distractor-header {
  font-size: 1rem;
  margin-bottom: 0.25rem;
}

.distractor-header .required {
  color: red;
  margin-left: 0.25rem;
}

.distractor-description {
  font-size: 0.875rem;
  color: #555;
  margin-bottom: 0.75rem;
}

.distractor-input-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1rem;
}

.custom-input {
  width: 200px;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.add-distractor-btn {
  background-color: transparent;
  border: 1px solid #4403bf;
  color: #4403bf;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.add-distractor-btn:hover {
  background-color: #4403bf;
  color: #fff;
}

.distractor-list {
  list-style: disc inside;
  padding-left: 1rem;
  margin: 0;
}

.distractor-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
}

.remove-distractor-btn {
  background: transparent;
  border: none;
  color: #4403bf;
  font-size: 0.85rem;
  cursor: pointer;
  transition: -webkit-text-decoration 0.2s;
  transition: text-decoration 0.2s;
  transition: text-decoration 0.2s, -webkit-text-decoration 0.2s;
}

.remove-distractor-btn:hover {
  text-decoration: underline;
}

td .tooltip {
  max-width: 300px !important;
  z-index: 1070;
}

td .tooltip-inner {
  max-width: 300px !important;
  text-align: left;
  padding: 8px 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/theme.scss"],"names":[],"mappings":"AACA;EACE,gCAAA;EACA,2FAAA;EAGA,kBAAA;AAFF;AAsCA;EACE,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,uDAAA;AAxCF;;AAgDA;;;;;;EAME,oBAAA;AA7CF;;AAgDA;EACE,kBAAA;EACA,kFAAA;EAIA,uDAAA;EACA,sBAAA;AAhDF;;AAmDA,kBAAA;AACA;EACE,6BAAA;AAhDF;;AAmDA;EACE,sCAAA;EACA,kCAAA;AAhDF;;AAmDA;EACE,kCAAA;AAhDF;;AAmDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;AAhDF;;AAmDA;EACE,6BAAA;AAhDF;;AAmDA;EACE,oCAAA;AAhDF;;AAmDA;EACE,qBAAA;EACA,0CAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AAhDF;;AAmDA;EACE,uBAAA;AAhDF;;AAmDA;EACE,yBAAA;AAhDF;;AAmDA;EACE,yBAAA;AAhDF;;AAmDA;EACE,4BAAA;EACA,6BAAA;AAhDF;;AAmDA,+BAAA;AACA;EACE,aAAA;AAhDF;;AAmDA,kBAAA;AACA;EACE,+BAAA;EACA,6BAAA;AAhDF;;AAmDA;EACE,kBAAA;EACA,+BAAA;AAhDF;;AAmDA,gBAAA;AACA;EACE,wCAAA;EACA,2BAAA;AAhDF;;AAmDA,mBAAA;AACA;EACE,6BAAA;EACA,+BAAA;EACA,YAAA;AAhDF;;AAmDA,8DAAA;AAEA;EACE,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;AAjDF;;AAoDA;EACE,WAAA;AAjDF;;AAoDA;EACE,YAAA;EACA,UAAA;AAjDF;;AAoDA;EACE,sBAAA;EACA,gCAAA;AAjDF;;AAoDA;EACE,aAAA;AAjDF;;AAoDA;EACE,WAAA;AAjDF;;AAoDA;EACE,WAAA;EACA,eAAA;AAjDF;;AAoDA;EACE,sBAAA;EACA,qBAAA;AAjDF;;AAoDA;EACE,sBAAA;EACA,qBAAA;AAjDF;;AAoDA;EACE,sBAAA;EACA,qBAAA;AAjDF;;AAoDA;EACE,sBAAA;EACA,qBAAA;AAjDF;;AAoDA;;;;EAIE,yBAAA;EACA,6CAAA;AAjDF;;AAqDA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAlDF;;AAqDA;EACE,sBAAA;EACA,mCAAA;EACA,eAAA;EACA,4BAAA;AAlDF;;AAqDA;EACE,gCAAA;EACA,WAAA;EACA,yCAAA;EACA,UAAA;AAlDF;;AAqDA,sEAAA;AAEA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;EACA,gCAAA;EACA,aAAA;EACA,kCAAA;AAnDF;;AAsDA;EACE,YAAA;AAnDF;;AAsDA,8DAAA;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,sDAAA;EACA,0BAAA;EACA,0CAAA;AApDF;;AAuDA;EACE,6BAAA;EACA,YAAA;AApDF;;AAuDA;EACE,6BAAA;EACA,0BAAA;EACA,YAAA;AApDF;;AAuDA;EACE,kBAAA;EACA,SAAA;EACA,0CAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,uCAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gDAAA;AApDF;;AAuDA;EACE,wBAAA;EACA,uBAAA;AApDF;;AAuDA;EACE,yBAAA;AApDF;;AAuDA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;AApDF;;AAuDA;EACE,0BAAA;AApDF;;AAuDA;EACE,0BAAA;AApDF;;AAuDA;EACE,UAAA;EACA,gBAAA;AApDF;;AAuDA;EACE,YAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,qBAAA;EACA,YAAA;AApDF;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AApDF;;AAyDA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;AAtDF;;AAyDA;EACE,uBAAA;EACA,0BAAA;AAtDF;;AAyDA;EACE,uBAAA;EACA,yBAAA;AAtDF;;AAyDA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;AAtDF;;AAyDA;EACE,oCAAA;AAtDF;;AAyDA;EACE,cApYO;AA8UT;;AAyDA;EACE,8BAAA;AAtDF;;AAyDA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAtDF;;AA2DA,qBAAA;AACA;EACE,aAAA;EACA,iBAAA;AAxDF;;AA2DA;EACE,mBAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;AAxDF;;AA2DA;EACE,UAAA;AAxDF;;AA2DA;EACE,UAAA;AAxDF;;AA2DA;EACE,aAAA;AAxDF;;AA2DA;EACE,aAAA;AAxDF;;AA2DA;EAEE,mBAAA;AAzDF;;AA4DA;EACE,SAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,cAAA;EACA,cArdO;AA4ZT;;AA4DA,+DAAA;AACA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,cA5ec;AAmbhB;;AA4DA;EACE,cAxeW;AA+ab;;AA4DA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAvfgB;EAwfhB,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,cA/eO;EAgfP,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,8CAAA;EACA,eAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cA/gBc;AAsdhB;;AA4DA;EACE,2DAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,cAzhBc;AAgehB;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,cA1kBa;AAihBf;;AA4DA;EACE,aAAA;EACA,8BAAA;AAzDF;;AA4DA;EACE,oCAAA;AAzDF;;AA4DA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,4CAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,4BAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,6BAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,oCAAA;AAzDF;;AAgEA;EACE,sBAAA;EACA,uBAAA;AA7DF;;AAgEA;EACE,eAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7DF;;AAgEA;EACE,uBAAA;EACA,yCAAA;AA7DF;;AAgEA;EACE,uBAAA;AA7DF;;AAgEA;EACE,aAAA;AA7DF;;AAgEA;EACE,wBAAA;AA7DF;;AAgEA;EACE,oBAAA;AA7DF;;AAgEA;EACE,oBAAA;AA7DF;;AAgEA;EACE,wBAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,yBAAA;AA7DF;;AAgEA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA7DF;;AAgEA;EACE,cAAA;AA7DF;;AAgEA;EACE,sBAAA;EACA,qBAAA;AA7DF;;AAgEA;EACE,6BAAA;AA7DF;;AAgEA;EACE,YAAA;EACA,wCAAA;AA7DF;;AAgEA;EACE,oEAAA;EACA,2DAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,uBAAA;EACA,mCAAA;AA7DF;;AAgEA;EACE,WAAA;EACA,YAAA;AA7DF;;AAgEA;EACE,4BAAA;AA7DF;;AAgEA;EAEE,QAAA;EACA,iBAAA;AA9DF;;AAiEA;EACE,uBAAA;EAAA,kBAAA;AA9DF;;AAkEA;EACE,eAAA;AA/DF;;AAkEA,yCAAA;AACA;EACE;IACE,aAAA;EA/DF;EAkEA;IACE,0BAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EAhEF;EAmEA;IACE,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;EAjEF;EAoEA;IACE,yBAAA;IACA,6BAAA;IACA,oBAAA;EAlEF;EAqEA;IACE,sBAAA;EAnEF;EAsEA;IACE,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;EApEF;EAuEA;IACE,eAAA;EArEF;EAwEA;IACE,eAAA;EAtEF;EAyEA;IACE,qBAAA;IACA,eAAA;IACA,YAAA;IACA,aAAA;EAvEF;EA0EA;IACE,qBAAA;IACA,eAAA;IACA,aAAA;IACA,aAAA;EAxEF;EA2EA;IACE,sBAAA;EAzEF;EA4EA;IACE,SAAA;EA1EF;EA6EA;IACE,YAAA;IACA,eAAA;IACA,uBAAA;IACA,2BAAA;IACA,mBAAA;IACA,UAAA;IACA,oBAAA;EA3EF;EA8EA;IACE,sBAAA;EA5EF;EA+EA;IACE,sBAAA;EA7EF;EAgFA;IACE,uBAAA;EA9EF;EAiFA;IACE,uBAAA;EA/EF;EAiFA;IACE,YAAA;IACA,gBAAA;EA/EF;AACF;AA+EI;EAHF;IAII,YAAA;EA5EJ;AACF;AArBA;EAoGE;IACE,yBAAA;EA5EF;EA+EA;IACE,wBAAA;EA7EF;EAgFA;IACE,qBAAA;EA9EF;EAiFA;IACE,uBAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,sCAAA;EA/EF;AACF;AAkFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;EAhFF;AACF;AAmFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;EAjFF;AACF;AAoFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;EAlFF;AACF;AAqFA;EACE,aAAA;EACA,mBAAA;AAnFF;;AAqFA;EACE,iCAAA,EAAA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAlFF;;AAoFA;EACE,2BAAA;EACA,uBAAA;EACA,UAAA;AAjFF;;AAoFA;EACE,8BAAA;AAjFF;;AAoFA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,sBAAA;AAjFF;;AAoFA;EACE,UAAA;EACA,oBAAA;AAjFF;;AAoFA;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAjFF;;AAoFA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAjFF;;AAoFA;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;AAjFF;;AAoFA;EACE,yBAAA;EACA,WAAA;AAjFF;;AAoFA;EACE,uBAAA;EACA,kBAAA;EACA,SAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjFF;;AAoFA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EAAA,gCAAA;EAAA,8DAAA;AAjFF;;AAoFA;EACE,0BAAA;AAjFF;;AAqFA;EACE,2BAAA;EACA,aAAA;AAlFF;;AAqFA;EACE,2BAAA;EACA,gBAAA;EACA,iBAAA;AAlFF","sourcesContent":["// styles/theme.scss\n@font-face {\n  font-family: \"Plus Jakarta Sans\";\n  src: local(\"Plus Jakarta Sans\"),\n    url(\"../../public/assets/fonts/PlusJakartaSans-VariableFont_wght.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n\n$font-family: \"Plus Jakarta Sans\", sans-serif;\n\n// Brand Colors\n$primary-color: #4403bf;\n$secondary-color: #fff;\n$darker-color: #290273;\n$lighter-color: #9275ed;\n$subtle-color: #d3c8ff;\n\n// State Colors\n$success-color: #06c270;\n$info-color: #0063f7;\n$warning-color: #ffcc00;\n$error-color: #ff3b3b;\n\n// Dark Colors\n$dark-1: #3a3a3c;\n$dark-2: #6b7588;\n$dark-3: #8f90a6;\n$dark-4: #c7c9d9;\n\n// Light Colors\n$light-1: #dde5e9;\n$light-2: #ebebf0;\n$light-3: #f2f2f5;\n$light-4: #fafafc;\n\n$font-regular: 400;\n$font-medium: 500;\n$font-semi-bold: 600;\n$font-bold: 700;\n\n// :root\n:root {\n  --primary-color: #4403bf;\n  --secondary-color: #fff;\n  --darker-color: #290273;\n  --lighter-color: #9275ed;\n  --subtle-color: #d3c8ff;\n\n  --success-color: #06c270;\n  --info-color: #0063f7;\n  --warning-color: #ffcc00;\n  --error-color: #ff3b3b;\n\n  --dark-1: #3a3a3c;\n  --dark-2: #6b7588;\n  --dark-3: #8f90a6;\n  --dark-4: #c7c9d9;\n\n  --light-1: #dde5e9;\n  --light-2: #ebebf0;\n  --light-3: #f2f2f5;\n  --light-4: #fafafc;\n\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n$theme-colors: (\n  primary: $primary-color,\n  secondary: $secondary-color,\n);\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0 !important;\n}\n\nbody {\n  --bs-bg-opacity: 1;\n  background-color: rgba(\n    var(--bs-tertiary-bg-rgb),\n    var(--bs-bg-opacity)\n  ) !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n  padding: 0% !important;\n}\n\n/* Button Styles */\n.btn {\n  color: var(--secondary-color);\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.top-screen-navbar {\n  background-color: white !important;\n}\n\n.sticky-sidebar-styles {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 16.6666667%;\n  overflow-y: auto;\n  z-index: 100;\n  align-items: flex-start;\n  height: 100%;\n  background-color: var(--dark-1);\n}\n\n.navlink-styles {\n  padding-left: 18px !important;\n}\n\n.selected-sidebar-link {\n  background-color: #4403bf !important;\n}\n\n.offcanvas {\n  width: 70% !important;\n  background-color: var(--dark-1) !important;\n  color: white !important;\n  z-index: 2;\n  padding-left: 0px;\n}\n\n.discussion-color {\n  color: white !important;\n}\n\n.sel-discussion-color {\n  color: #4403bf !important;\n}\n\n.sel-discussion-color:hover {\n  color: #4403bf !important;\n}\n\n.offcanvas-body {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n/* Define the scrollbar style */\n.sticky-sidebar-styles::-webkit-scrollbar {\n  display: none;\n}\n\n/* Header Styles */\n.navbar {\n  background-color: var(--dark-1);\n  color: var(--secondary-color);\n}\n\n.custom-margin-right {\n  margin-right: 10px;\n  /* Adjust the value as needed */\n}\n\n/* Card Styles */\n.card {\n  background-color: var(--secondary-color);\n  color: var(--primary-color);\n}\n\n/* Sidebar Styles */\n.sidebar {\n  color: var(--secondary-color);\n  background-color: var(--dark-1);\n  height: auto;\n}\n\n/* Add these styles in your CSS or use a separate stylesheet */\n\n.sidebar-container {\n  background-color: #343a40;\n  /* Dark background color */\n  height: 100vh;\n  overflow-x: hidden;\n  width: 250px;\n  /* Adjust the width as needed */\n  position: fixed;\n  transition: width 0.3s;\n  /* Add transition for smoother animation */\n}\n\n.sidebar-container .navbar {\n  width: 100%;\n}\n\n.sidebar-container .navbar-toggler {\n  border: none;\n  padding: 0;\n}\n\n.sidebar-container .navbar-toggler-icon {\n  background-color: #fff;\n  /* Color of the hamburger icon */\n}\n\n.sidebar-container .navbar-collapse {\n  padding: 20px;\n}\n\n.sidebar-container .navbar-nav {\n  width: 100%;\n}\n\n.sidebar-container .nav-link {\n  color: #fff;\n  /* Text color */\n}\n\n.nav-link:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div div:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div div svg:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.sidebar-container .navbar-nav .active > .nav-link,\n.sidebar-container .navbar-nav .nav-link.active,\n.sidebar-container .navbar-nav .nav-link.show,\n.sidebar-container .navbar-nav .show > .nav-link {\n  background-color: #495057;\n  /* Background color for active/hovered link */\n}\n\n// Add this in your styles/theme.scss or a separate CSS file\n.navbar .nav-link.heading::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1px;\n  /* Adjust the height of the line as needed */\n  background-color: #6e6e6f;\n  /* Use the appropriate color */\n  opacity: 10;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.sidebar-item {\n  transition: color 0.3s;\n  /* Add a smooth transition effect */\n  cursor: pointer;\n  /* Change cursor to a hand */\n}\n\n.sidebar-item:hover {\n  /* Bright white color on hover */\n  color: #fff;\n  /* Change text color on hover if needed */\n  opacity: 1;\n}\n\n/* Add these styles in your styles/theme.scss or a separate CSS file */\n\n.mobile-view {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: var(--light-4);\n  /* Adjust this color as needed */\n  padding: 10px;\n  /* Adjust this padding as needed */\n}\n\n.mobile-view .nav-link {\n  flex-grow: 1;\n}\n\n/* Add these styles in your CSS or use a separate stylesheet */\n\n.sidebar-item .dropdown-arrow {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 6px 6px 0 6px;\n  border-color: #fff transparent transparent transparent;\n  transition: transform 0.3s;\n  /* Add transition for smoother animation */\n}\n\n.logout-dropdown .dropdown-menu.show {\n  position: absolute !important;\n  left: -147px;\n}\n\n.questionBank .dropdown-menu {\n  position: relative !important;\n  transform: none !important;\n  border: none;\n}\n\n.sidebar-item .dropdown-menu {\n  position: absolute;\n  top: 100%;\n  /* Adjust positioning to prevent overlap */\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  background-color: #343a40;\n  /* Dark background color */\n  transition: max-height 0.3s ease-in-out;\n  /* Add transition for smoother animation */\n  max-height: 0;\n  overflow: hidden;\n  z-index: 1;\n  /* Ensure the dropdown is above other elements */\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n  /* Hide default arrow */\n}\n\n.sidebar-item:hover .custom-arrow {\n  transform: rotate(180deg);\n}\n\n.coursework-sidebar {\n  width: 100%;\n  background-color: white;\n  height: 100%;\n  color: black;\n  border: 1px solid lightgrey;\n}\n\n.coursework-content {\n  padding: 10px 0px 0px 20px;\n}\n\n.coursework-heading {\n  padding: 25px 0px 0px 20px;\n}\n\n.coursework-sidebar ul {\n  padding: 0;\n  list-style: none;\n}\n\n.coursework-sidebar li {\n  padding: 2px;\n  margin-bottom: 10px;\n}\n\n.coursework-sidebar li a {\n  text-decoration: none;\n  color: black;\n}\n\n.profile_main_div {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n$input-placeholder-color: $dark-4;\n\n.react-tel-input .form-control {\n  width: 100% !important;\n  height: 42px !important;\n  font-size: 16px !important;\n}\n\n.right-side .form-control {\n  height: 42px !important;\n  font-size: 16px !important;\n}\n\n.right-side .input-group {\n  height: 42px !important;\n  border: 1px solid #e9eaf0;\n}\n\n.input-style {\n  padding: 8px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  line-height: 1.5 !important;\n}\n\n.form-check-input:checked {\n  background-color: #0d6efd !important;\n}\n\n.input-placeholder {\n  color: $input-placeholder-color; // Use the placeholder color variable\n}\n\n.modal-body .multiValue {\n  border-radius: 50px !important;\n}\n\n.button-style {\n  box-sizing: border-box;\n  border-radius: 5px;\n  background: #4403bf;\n  justify-content: flex-start;\n  align-items: center;\n  display: center;\n  color: white;\n  font-size: 16px;\n  line-height: 27px;\n  letter-spacing: 0.04px;\n  word-wrap: break-word;\n  border: none; // Remove border if not needed\n  cursor: pointer; // Add pointer cursor for interaction\n  text-align: center;\n}\n\n// Login\n\n/* styles/Login.css */\n.login-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n.login-heading {\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.left-side {\n  min-height: 100vh;\n  flex: 3;\n  background: #ffeee8;\n  position: sticky;\n  top: 0;\n}\n\n.mobile-create-btns {\n  width: 70%;\n}\n\nmobile-create-btns {\n  width: 70%;\n}\n\n.mobile-forgot {\n  display: none;\n}\n\n.forgot-icon {\n  display: none;\n}\n\n.otp-icon-div {\n  // display: none;\n  margin-bottom: 20px;\n}\n\n.right-side {\n  flex: 3;\n  padding: 40px 144px 40px 100px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  position: relative;\n}\n\nlabel {\n  font-size: 13px;\n  display: block;\n  color: $dark-3;\n}\n\n/* Add your styles for Input, Button, and other elements here */\n.forgot-password-link {\n  margin-top: 10px;\n  text-decoration: none;\n  cursor: pointer;\n  color: $primary-color;\n}\n\n.otp-phone {\n  color: $info-color;\n}\n\n.google-button {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  background: $secondary-color;\n  justify-content: flex-start;\n  align-items: center;\n  display: center;\n  color: $dark-1;\n  font-size: 16px;\n  line-height: 27px;\n  letter-spacing: 0.04px;\n  word-wrap: break-word;\n  border: 1px solid white; // Remove border if not needed\n  box-shadow: 2px 2px 4px rgb(94 92 92 / 64%);\n  cursor: pointer; // Add pointer cursor for interaction\n  text-align: center;\n}\n\n.google-icon {\n  margin-right: 10px;\n}\n\n.signup-link {\n  margin: 0;\n  cursor: pointer;\n  text-decoration: none;\n  color: $primary-color;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  content: url(\"../../public/chevron-right.svg\") !important;\n  margin-top: 3px;\n}\n\n.breadcrumb-item a {\n  text-decoration: none !important;\n  color: $primary-color;\n}\n\n.categoriesAccordion .accordion-item:first-of-type .accordion-button {\n  background-color: white;\n}\n\n.profile_main_div .dropdown-menu .show {\n  left: -146px !important;\n  top: 40px;\n}\n\n.filter-students .dropdown-menu .show {\n  left: 0px !important;\n}\n\n.delete-edit-icon {\n  height: 40px;\n  padding: 9.99px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10.99px;\n  display: inline-flex;\n  background-color: white;\n}\n\n.delete-edit-stu-icon {\n  height: 40px;\n  padding: 9.99px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10.99px;\n  display: inline-flex;\n}\n\n.delete-edit-stu-icon img {\n  width: 20px !important;\n}\n\n.delete-edit-icon img {\n  width: 20px !important;\n}\n\n.save-btn {\n  width: auto;\n}\n\n.deleteBtnModal {\n  border-radius: 28px;\n  border: 8px solid rgba(217, 247, 42, 0.2);\n  background: rgba(217, 247, 42, 0.3);\n  color: $darker-color;\n}\n\n.mblCards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.card-header {\n  background-color: #ffffff !important;\n}\n\n.mblCards-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\ntable {\n  border: 1.391px solid var(--Grey_2, #e4e4e4);\n  border-radius: 5px;\n}\n\ntr {\n  height: 55px !important;\n  text-align: start !important;\n}\n\ntd {\n  position: relative;\n  height: 55px !important;\n  padding: 12px 24px !important;\n  text-align: start !important;\n  width: inherit !important;\n}\n\ntd > div:first-child {\n  height: 100% !important;\n  display: flex;\n  align-items: center;\n  width: 100% !important;\n}\n\nth {\n  position: relative;\n  padding: 12px 24px !important;\n}\n\n.table-checkbox {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n}\n\n.table-checkbox:checked {\n  background-color: $darker-color !important;\n}\n\n// table input:checked {\n//   background-color: $darker-color !important;\n// }\n\n.mbl-card-checkbox {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.card-heading {\n  font-size: 14px;\n  color: var(--Grey_4, #1b2128);\n  text-decoration: none;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.Accordion-card {\n  height: 60px !important;\n  border-radius: 6px 6px 0px 0px !important;\n}\n\n.Accordion-card .card-header {\n  height: 100% !important;\n}\n\n.sm-table {\n  display: none;\n}\n\n.tox-promotion-link {\n  display: none !important;\n}\n\n.options-addQuestion p {\n  margin: 0 !important;\n}\n\n.formattedText p {\n  margin: 0 !important;\n}\n\n.tox-statusbar {\n  display: none !important;\n}\n\n.equation_image {\n  position: relative;\n  max-width: 75% !important;\n}\n\n.equation_tooltip {\n  display: none;\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #000;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.equation_image:hover + .equation_tooltip {\n  display: block;\n}\n\n.mq-math-mode .mq-sqrt-prefix {\n  left: 0.3em !important;\n  top: 0.2em !important;\n}\n\n.mq-math-mode sup.mq-nthroot {\n  padding-top: 0.3em !important;\n}\n\n.accordion-button {\n  height: 100%;\n  background-color: transparent !important;\n}\n\n.custom-select__multi-value__remove {\n  background-image: url(\"../../public/cross.png\") !important;\n  /* Set appropriate width and height for your custom image */\n  width: 20px;\n  height: 20px;\n  /* Ensure the image is displayed properly */\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  border: none !important;\n  /* Ensure cursor changes on hover */\n}\n\n#custom-switch {\n  width: 45px;\n  height: 25px;\n}\n\n.accordion-button {\n  padding: 8px 16px !important;\n}\n\n.formattedText {\n  // display: flex;\n  gap: 5px;\n  line-height: 30px;\n}\n\n.formattedText > span:first-child {\n  width: fit-content;\n  // height: 25px;\n}\n\n.inlineMath {\n  display: inline;\n}\n\n/* Add media queries for responsiveness */\n@media (max-width: 780px) {\n  .login-container .left-side {\n    display: none;\n  }\n\n  .login-container .right-side {\n    padding: 0px 20px 0px 20px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0px;\n  }\n\n  .forgot-icon {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 30px;\n  }\n\n  .mobile-forgot {\n    display: block !important;\n    text-align: center !important;\n    padding-bottom: 30px;\n  }\n\n  .otp-main-div {\n    width: 100% !important;\n  }\n\n  .otp-icon-div {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 30px;\n    margin-top: 40px;\n  }\n\n  .otp-heading {\n    font-size: 20px;\n  }\n\n  .otp-phone {\n    font-size: 20px;\n  }\n\n  .mobile-create-btns {\n    width: 90% !important;\n    position: fixed;\n    bottom: 90px;\n    z-index: 1000;\n  }\n\n  .mobile-create-btns-2nd {\n    width: 90% !important;\n    position: fixed;\n    bottom: 145px;\n    z-index: 1000;\n  }\n\n  .login-container {\n    flex-direction: column;\n  }\n\n  .right-side {\n    flex: 1;\n  }\n\n  .delete-edit-icon {\n    height: 100%;\n    padding: 8.99px;\n    border: none !important;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10.99;\n    display: inline-flex;\n  }\n\n  .delete-edit-icon img {\n    width: 20px !important;\n  }\n\n  .save-btn {\n    width: 100% !important;\n  }\n\n  .fix-width-button {\n    width: 100px !important;\n  }\n\n  .fix-width-action-button {\n    width: 140px !important;\n  }\n  .content-div {\n    height: 55vh;\n    overflow-y: auto;\n    @media (max-width: 768px) {\n      padding: 7px; // Adjust padding for smaller screens\n    }\n  }\n\n  .sidebar {\n    background-color: #ffffff;\n  }\n\n  .lg-table {\n    display: none !important;\n  }\n\n  .sm-table {\n    display: inline-table;\n  }\n\n  td > div:first-child {\n    height: 100% !important;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n    justify-content: flex-start !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 270px;\n    /* Adjust this value to your liking */\n  }\n}\n\n@media (max-width: 400px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 220px;\n    /* Adjust this value to your liking */\n  }\n}\n\n@media (max-width: 350px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 180px;\n    /* Adjust this value to your liking */\n  }\n}\n\n.subscription-info {\n  display: flex;\n  align-items: center;\n}\n.subscription-box {\n  background-color: blue !important; /* Adjust this color to match your design */\n  color: white;\n  padding: 11px 14px;\n  border-radius: 5px;\n  margin-right: 15px;\n  font-weight: bold;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n}\n.logout-dropdown .dropdown-toggle {\n  background: none !important;\n  border: none !important;\n  padding: 0;\n}\n\n.ql-editor {\n  white-space: normal !important;\n}\n\n.distractor-section {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f7f7f7;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.distractor-header {\n  font-size: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.distractor-header .required {\n  color: red;\n  margin-left: 0.25rem;\n}\n\n.distractor-description {\n  font-size: 0.875rem;\n  color: #555;\n  margin-bottom: 0.75rem;\n}\n\n.distractor-input-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.custom-input {\n  width: 200px;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.add-distractor-btn {\n  background-color: transparent;\n  border: 1px solid #4403bf;\n  color: #4403bf;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.add-distractor-btn:hover {\n  background-color: #4403bf;\n  color: #fff;\n}\n\n.distractor-list {\n  list-style: disc inside;\n  padding-left: 1rem;\n  margin: 0;\n}\n\n.distractor-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.25rem 0;\n}\n\n.remove-distractor-btn {\n  background: transparent;\n  border: none;\n  color: #4403bf;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: text-decoration 0.2s;\n}\n\n.remove-distractor-btn:hover {\n  text-decoration: underline;\n}\n\n// Fix tooltip alignment in tables\ntd .tooltip {\n  max-width: 300px !important;\n  z-index: 1070;\n}\n\ntd .tooltip-inner {\n  max-width: 300px !important;\n  text-align: left;\n  padding: 8px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
